export default __webpack_public_path__ + "static/media/share.f5384a9a.svg";